module.exports = __webpack_public_path__ + "static/media/Pin.af11ddb0.svg";